{
    "ExcludeheldtimeLabel": "remover tempo de espera:",
    "TalkTime_SectionHeader": "Tempo de conversação",
    "TalkTime_SectionPara": "Pode escolher se as estatísticas relacionadas com o tempo de conversação da chamada devem excluir o tempo em espera da lógica de cálculo.",
    "NAME": "TalkTime"
}